module.exports = __webpack_public_path__ + "img/肖志峰副教授.735ca34b.png";